import { render } from "./inviteForm.vue?vue&type=template&id=b23ae064&scoped=true"
import script from "./inviteForm.vue?vue&type=script&lang=js"
export * from "./inviteForm.vue?vue&type=script&lang=js"

import "./inviteForm.vue?vue&type=style&index=0&id=b23ae064&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b23ae064"

export default script